
import store from "../store"; //vuex
import { MachineNamespace } from "@/store/machine";

export class RoadMapDataParse {

    constructor() {
    }

    MakeRoadMapImage(machineId) 
    {
        const machine_list = store.getters[`${MachineNamespace}/getRoadMapList`];

        const findIndex = machine_list.findIndex(e => e.machineId == machineId)
        if (findIndex != -1)
        {
            const webRoadmapList = machine_list[findIndex].webRoadMap
            const canvas = document.createElement('canvas');

            canvas.width = 199;
            canvas.height = 113;
            
            const ctx = canvas.getContext("2d");
            ctx.transform(1, 0, 0, 1, 0, 0)

            const xArray = [180, 170, 160, 150, 140, 130, 120, 110, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10];
            const yArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

            let xArrayCount = 0;

            for (let k = 0; k < webRoadmapList.length; k++) 
            {
                let roadMapId = webRoadmapList[k].roadMapId

                for (let i = xArrayCount; i < xArray.length; i++) 
                {
                    let x = xArray[i] / 0.91;
                        
                    let bStop = false;
                    for (let j = 0; j < yArray.length; j++) 
                    {
                    let y = ((yArray[j] + 1) * 10) / 0.9;
                
                    let color = "#347C00";
                    if(roadMapId == (xArray[i] * 10) + yArray[j])
                    {
                        switch(webRoadmapList[k].winType)
                        {
                            case 1:
                                color = "#0057D9";
                                break;
                            case 2:
                                color = "#DFA825";
                                break;
                        }
                    
                        ctx.fillStyle = color;
                        ctx.beginPath();
                        ctx.ellipse(x-5, y-5, 4.5, 4.5, 0, 0, Math.PI * 2);
                        ctx.fill();
                        
                        bStop = true;
                        break;
                    }
                    else
                    {
                        ctx.fillStyle = color;
                        ctx.beginPath();
                        ctx.ellipse(x-5, y-5, 4.5, 4.5, 0, 0, Math.PI * 2);
                        ctx.fill();
                    }
                    }
                    
                    if(bStop)
                    {
                    xArrayCount++;
                        break;
                    }
                }
            }
            return canvas.toDataURL('image/png')
        }
        return "";
    }
}
